
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { RegionalService } from '../regional-service/regional.service';
import { ListaBase } from './../../../../shared/crud/ListaBase';
import { EstruturaGridViewBuilder } from './../../../../shared/gridview/EstruturaGridViewBuilder';
import { ParametroRegional } from './../../../../shared/service-base/parametro_regional';

@Component({
  selector: 'app-regional-lista',
  templateUrl: '../../template/lista.html',
  styleUrls: ['./regional-lista.component.css']
})
export class RegionalListaComponent
  extends ListaBase
  implements OnInit {
  visualizarTotalRegistros: boolean;
  exibirBotaoDetalhes: boolean;

  constructor(service: RegionalService, toastr: ToastrService, router: Router) {
    super(service, toastr, router);
    this.visualizarTotalRegistros = true;
    this.listagemComPaginacao = true;
    this.quantidadeRegistrosPorPagina = 5;
    this.exibirBotaoDetalhes = true;
  }

  ngOnInit() {
    this.buscar();
    this.estrutura = new EstruturaGridViewBuilder()
      .addColuna('usuario_nome', 'Usuário')
      .addColuna('regiao_nome', 'Região')
      .build();
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.id_usuario
      || this.filtros.id_regiao;
  }


  protected carregarModel(registro: any): Promise<any> {
    const parametros: ParametroRegional[] = [];
    const param = new ParametroRegional('id', registro.registro.id,
                                        registro.registro.usuario.id,
                                        registro.registro.regiao.id);
    parametros.push(param);
    this.carregando = true;

    return this.service.get(parametros)
      .then(res => {
        const retorno: any = {};
        retorno.registro = res.dados[0];
        this.carregando = false;

        return retorno;
      })
      .catch(error => {
        this.tratarErro('Não foi posível carregar o registro', 'Erro', error);
      })
  }
}
